import {
    FormControl,
    ToggleButton,
    ToggleButtonGroup,
    ToggleButtonGroupProps,
} from '@mui/material'
import React from 'react'
import { Controller, UseControllerProps, useFormContext } from 'react-hook-form'

type Options = {
    value: string
    label: React.ReactNode | (() => React.ReactNode)
    disabled?: boolean
}

type FormsProps = Omit<UseControllerProps, 'control'> &
    ToggleButtonGroupProps & {
        children?: React.ReactNode
        name: string
        options: Options[] | undefined
        defaultValue?: string
    }

export default function FormFieldToggleButtonGroup({
    name,
    rules,
    options,
    defaultValue = '',
    onChange,
    shouldUnregister,
    ...props
}: FormsProps) {
    const { control } = useFormContext()
    const disabled = props.disabled || (control as any)._options?.disabled

    return (
        <Controller
            name={name}
            rules={rules}
            control={control}
            defaultValue={defaultValue}
            shouldUnregister={shouldUnregister}
            render={({ field }) => (
                <FormControl
                    fullWidth
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '1rem',
                    }}
                >
                    <ToggleButtonGroup
                        {...props}
                        {...field}
                        disabled={disabled}
                        defaultValue={defaultValue}
                        onChange={(event, child) => {
                            field.onChange(event)
                            if (onChange) {
                                onChange(event, child)
                            }
                        }}
                    >
                        {options?.map(({ value, label, disabled }) => (
                            <ToggleButton
                                key={value}
                                value={value}
                                disabled={disabled}
                            >
                                {typeof label === 'function' ? label() : label}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </FormControl>
            )}
        />
    )
}
